import { IRequestConfig } from "~/modules/@xy/request/src/types/fetch-type";
import {
  XyConsoleBannerGetParams,
  XyConsoleConsoleSysDeptDeleteDeleteParams,
  XyConsoleConsoleSysDeptQueryGetParams,
  XyConsoleConsoleSysResourceButtonsAndApisBatchGetParams,
  XyConsoleConsoleSysResourceGetParams,
  XyConsoleConsoleSysResourceTreeGetParams,
  XyConsoleConsoleSysRoleDeleteDeleteParams,
  XyConsoleConsoleSysRoleQueryAllGetParams,
  XyConsoleConsoleSysRoleQueryGetParams,
  XyConsoleConsoleSysUserDeleteDeleteParams,
  XyConsoleConsoleSysUserQueryGetParams,
  XyConsoleConsoleSysUserResetDefaultDeleteParams,
  XyConsoleGoodsGaiaGoodsDetailGetParams,
  XyConsoleGoodsGaiaGoodsPageGetParams,
  XyConsoleGoodsGetParams,
  XyConsoleGoodsPageIgnoreIntegralGoodsGetParams,
  XyConsoleGoodsSimplePageGetParams,
  XyConsoleGoodsSkuIntegralStockRecordGetParams,
  XyConsoleGroupApprovesGetParams,
  XyConsoleGroupsGetParams,
  XyConsoleGroupsSimpleGetParams,
  XyConsoleIntegralGoodsCategoryGetParams,
  XyConsoleIntegralGoodsGetParams,
  XyConsoleLiveGetParams,
  XyConsoleMuteWordsGetParams,
  XyConsoleOrderGetParams,
  XyConsoleOrderIntegralListGetParams,
  XyConsoleOssPolicyGetParams,
  XyConsolePostsGetParams,
  XyConsoleProblemGetParams,
  XyConsolePublicJstDeliverPostParams,
  XyConsoleSurveyTemplatesGetParams,
  XyConsoleTagsGetParams,
  XyConsoleTasksGetParams,
  XyConsoleTaskValidatorsDetailsGetParams,
  XyConsoleTaskValidatorsGetParams,
  XyConsoleTestHelloGetParams,
  XyConsoleTopicsGetParams,
  XyConsoleTrialGetParams,
  XyConsoleTrialRecordGetParams,
  XyConsoleUserGetParams,
  XyConsoleUserGrowthRecordGetParams,
  XyConsoleUserIntegralRecordAuditGetParams,
  XyConsoleUserIntegralRecordGetParams,
  XyConsoleUserInvitedRecordGetParams,
  XyConsoleUserSimpleGetParams,
  XyConsoleWorkOrderGetParams
} from "./data-contracts";
import requestInstance from "./instance";

type RequestConfig = Omit<IRequestConfig, "url" | "method">;

export const API = {
  /**
   * No description
   * @name DELETE /xy/console/goods/{id}
   * @summary delete
   * @tags goods-controller
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/goods/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/goods/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/goods/{id}
   * @summary detail
   * @tags goods-controller
   * @response `200` `{ code?: number, data?: { bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean }, msg?: string }` successful operation
   */
  "/xy/console/goods/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/goods/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        bannerImgs?: string[];
        code?: string;
        coverImg?: string;
        detailDesc?: string;
        gmtCreate?: string;
        gmtModified?: string;
        goodsPropertyList?: {
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          propName?: string;
          propertyValueList?: object[];
        }[];
        id?: number;
        integralIs?: boolean;
        name?: string;
        outerId?: string;
        salesVolume?: number;
        skuList?: {
          code?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          integral?: number;
          integralSalesVolume?: number;
          integralShelfIs?: boolean;
          integralStock?: number;
          outerId?: string;
          outerPrice?: number;
          price?: number;
          salesVolume?: number;
          shelfIs?: boolean;
          skuImg?: string;
          skuName?: string;
          specIds?: number[];
          specNames?: string[];
          stock?: number;
          version?: string;
        }[];
        stock?: number;
        trialIs?: boolean;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/goods/detailIgnoreOffSku/{id}
   * @summary detailIgnoreOffSku
   * @tags goods-controller
   * @response `200` `{ code?: number, data?: { bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean }, msg?: string }` successful operation
   */
  "/xy/console/goods/detailIgnoreOffSku/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/goods/detailIgnoreOffSku/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        bannerImgs?: string[];
        code?: string;
        coverImg?: string;
        detailDesc?: string;
        gmtCreate?: string;
        gmtModified?: string;
        goodsPropertyList?: {
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          propName?: string;
          propertyValueList?: object[];
        }[];
        id?: number;
        integralIs?: boolean;
        name?: string;
        outerId?: string;
        salesVolume?: number;
        skuList?: {
          code?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          integral?: number;
          integralSalesVolume?: number;
          integralShelfIs?: boolean;
          integralStock?: number;
          outerId?: string;
          outerPrice?: number;
          price?: number;
          salesVolume?: number;
          shelfIs?: boolean;
          skuImg?: string;
          skuName?: string;
          specIds?: number[];
          specNames?: string[];
          stock?: number;
          version?: string;
        }[];
        stock?: number;
        trialIs?: boolean;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/goods/gaiaGoodsDetail/{outerId}
   * @summary gaiaGoodsDetail
   * @tags goods-controller
   * @response `200` `{ code?: number, data?: { bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], goodsSpecList?: ({ children?: (any)[], gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, name?: string, pid?: number })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean }, msg?: string }` successful operation
   */
  "/xy/console/goods/gaiaGoodsDetail/{outerId}_GET": (outerId: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/goods/gaiaGoodsDetail/${outerId}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        bannerImgs?: string[];
        code?: string;
        coverImg?: string;
        detailDesc?: string;
        gmtCreate?: string;
        gmtModified?: string;
        goodsPropertyList?: {
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          propName?: string;
          propertyValueList?: object[];
        }[];
        goodsSpecList?: {
          children?: any[];
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          name?: string;
          pid?: number;
        }[];
        id?: number;
        integralIs?: boolean;
        name?: string;
        outerId?: string;
        salesVolume?: number;
        skuList?: {
          code?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          integral?: number;
          integralSalesVolume?: number;
          integralShelfIs?: boolean;
          integralStock?: number;
          outerId?: string;
          outerPrice?: number;
          price?: number;
          salesVolume?: number;
          shelfIs?: boolean;
          skuImg?: string;
          skuName?: string;
          specIds?: number[];
          specNames?: string[];
          stock?: number;
          version?: string;
        }[];
        stock?: number;
        trialIs?: boolean;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/goods/gaiaGoodsDetail
   * @summary gaiaGoodsDetail
   * @tags goods-controller
   * @response `200` `{ code?: number, data?: { bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean }, msg?: string }` successful operation
   */
  "/xy/console/goods/gaiaGoodsDetail_GET": (
    query: XyConsoleGoodsGaiaGoodsDetailGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/goods/gaiaGoodsDetail`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        bannerImgs?: string[];
        code?: string;
        coverImg?: string;
        detailDesc?: string;
        gmtCreate?: string;
        gmtModified?: string;
        goodsPropertyList?: {
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          propName?: string;
          propertyValueList?: object[];
        }[];
        id?: number;
        integralIs?: boolean;
        name?: string;
        outerId?: string;
        salesVolume?: number;
        skuList?: {
          code?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          integral?: number;
          integralSalesVolume?: number;
          integralShelfIs?: boolean;
          integralStock?: number;
          outerId?: string;
          outerPrice?: number;
          price?: number;
          salesVolume?: number;
          shelfIs?: boolean;
          skuImg?: string;
          skuName?: string;
          specIds?: number[];
          specNames?: string[];
          stock?: number;
          version?: string;
        }[];
        stock?: number;
        trialIs?: boolean;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/goods/gaiaGoodsPage
   * @summary gaiaGoodsPage
   * @tags goods-controller
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/goods/gaiaGoodsPage_GET": (
    query: XyConsoleGoodsGaiaGoodsPageGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/goods/gaiaGoodsPage`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          bannerImgs?: string[];
          code?: string;
          coverImg?: string;
          detailDesc?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsPropertyList?: {
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            propName?: string;
            propertyValueList?: object[];
          }[];
          id?: number;
          integralIs?: boolean;
          name?: string;
          outerId?: string;
          salesVolume?: number;
          skuList?: {
            code?: string;
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            integral?: number;
            integralSalesVolume?: number;
            integralShelfIs?: boolean;
            integralStock?: number;
            outerId?: string;
            outerPrice?: number;
            price?: number;
            salesVolume?: number;
            shelfIs?: boolean;
            skuImg?: string;
            skuName?: string;
            specIds?: number[];
            specNames?: string[];
            stock?: number;
            version?: string;
          }[];
          stock?: number;
          trialIs?: boolean;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xy/console/goods
   * @summary insert
   * @tags goods-controller
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/goods_POST": (
    root: {
      bannerImgs?: string[];
      beginTime?: string;
      code?: string;
      coverImg?: string;
      detailDesc?: string;
      endTime?: string;
      id?: number;
      ignoreIds?: number[];
      integralIs?: boolean;
      keyword?: string;
      name?: string;
      orderField?: string;
      orderScheme?: "ASC" | "DESC";
      outerId?: string;
      pageNum?: number;
      pageSize?: number;
      skuList?: {
        beginTime?: string;
        changeIntegralStock?: number;
        changeStock?: number;
        code?: string;
        endTime?: string;
        goodsId?: number;
        id?: number;
        integral?: number;
        integralSalesVolume?: number;
        integralShelfIs?: boolean;
        integralStock?: number;
        keyword?: string;
        orderField?: string;
        orderScheme?: "ASC" | "DESC";
        outerId?: string;
        outerPrice?: number;
        pageNum?: number;
        pageSize?: number;
        price?: number;
        salesVolume?: number;
        shelfIs?: boolean;
        skuImg?: string;
        skuName?: string;
        specIds?: number[];
        specNames?: string[];
        stock?: number;
        timeField?: string;
      }[];
      timeField?: string;
      trialIs?: boolean;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/goods`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/goods
   * @summary page
   * @tags goods-controller
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/goods_GET": (query: XyConsoleGoodsGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/goods`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          bannerImgs?: string[];
          code?: string;
          coverImg?: string;
          detailDesc?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsPropertyList?: {
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            propName?: string;
            propertyValueList?: object[];
          }[];
          id?: number;
          integralIs?: boolean;
          name?: string;
          outerId?: string;
          salesVolume?: number;
          skuList?: {
            code?: string;
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            integral?: number;
            integralSalesVolume?: number;
            integralShelfIs?: boolean;
            integralStock?: number;
            outerId?: string;
            outerPrice?: number;
            price?: number;
            salesVolume?: number;
            shelfIs?: boolean;
            skuImg?: string;
            skuName?: string;
            specIds?: number[];
            specNames?: string[];
            stock?: number;
            version?: string;
          }[];
          stock?: number;
          trialIs?: boolean;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xy/console/goods
   * @summary update
   * @tags goods-controller
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/goods_PUT": (
    root: {
      bannerImgs?: string[];
      beginTime?: string;
      code?: string;
      coverImg?: string;
      detailDesc?: string;
      endTime?: string;
      id?: number;
      ignoreIds?: number[];
      integralIs?: boolean;
      keyword?: string;
      name?: string;
      orderField?: string;
      orderScheme?: "ASC" | "DESC";
      outerId?: string;
      pageNum?: number;
      pageSize?: number;
      skuList?: {
        beginTime?: string;
        changeIntegralStock?: number;
        changeStock?: number;
        code?: string;
        endTime?: string;
        goodsId?: number;
        id?: number;
        integral?: number;
        integralSalesVolume?: number;
        integralShelfIs?: boolean;
        integralStock?: number;
        keyword?: string;
        orderField?: string;
        orderScheme?: "ASC" | "DESC";
        outerId?: string;
        outerPrice?: number;
        pageNum?: number;
        pageSize?: number;
        price?: number;
        salesVolume?: number;
        shelfIs?: boolean;
        skuImg?: string;
        skuName?: string;
        specIds?: number[];
        specNames?: string[];
        stock?: number;
        timeField?: string;
      }[];
      timeField?: string;
      trialIs?: boolean;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/goods`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/goods/pageIgnoreIntegralGoods
   * @summary pageIgnoreIntegralGoods
   * @tags goods-controller
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/goods/pageIgnoreIntegralGoods_GET": (
    query: XyConsoleGoodsPageIgnoreIntegralGoodsGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/goods/pageIgnoreIntegralGoods`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          bannerImgs?: string[];
          code?: string;
          coverImg?: string;
          detailDesc?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsPropertyList?: {
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            propName?: string;
            propertyValueList?: object[];
          }[];
          id?: number;
          integralIs?: boolean;
          name?: string;
          outerId?: string;
          salesVolume?: number;
          skuList?: {
            code?: string;
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            integral?: number;
            integralSalesVolume?: number;
            integralShelfIs?: boolean;
            integralStock?: number;
            outerId?: string;
            outerPrice?: number;
            price?: number;
            salesVolume?: number;
            shelfIs?: boolean;
            skuImg?: string;
            skuName?: string;
            specIds?: number[];
            specNames?: string[];
            stock?: number;
            version?: string;
          }[];
          stock?: number;
          trialIs?: boolean;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/goods/simplePage
   * @summary simplePage
   * @tags goods-controller
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/goods/simplePage_GET": (
    query: XyConsoleGoodsSimplePageGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/goods/simplePage`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          bannerImgs?: string[];
          code?: string;
          coverImg?: string;
          detailDesc?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsPropertyList?: {
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            propName?: string;
            propertyValueList?: object[];
          }[];
          id?: number;
          integralIs?: boolean;
          name?: string;
          outerId?: string;
          salesVolume?: number;
          skuList?: {
            code?: string;
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            integral?: number;
            integralSalesVolume?: number;
            integralShelfIs?: boolean;
            integralStock?: number;
            outerId?: string;
            outerPrice?: number;
            price?: number;
            salesVolume?: number;
            shelfIs?: boolean;
            skuImg?: string;
            skuName?: string;
            specIds?: number[];
            specNames?: string[];
            stock?: number;
            version?: string;
          }[];
          stock?: number;
          trialIs?: boolean;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/test/hello
   * @summary hello
   * @tags hello-controller
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/test/hello_GET": (
    query: XyConsoleTestHelloGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/test/hello`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/console/sysConfig/task
   * @summary 更新固定任务配置
   * @tags 系统-配置管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/console/sysConfig/task_PUT": (
    root: { growth?: number; integral?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysConfig/task`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/console/sysConfig/task
   * @summary 获取固定任务配置
   * @tags 系统-配置管理
   * @response `200` `{ code?: number, data?: { growth?: number, integral?: number }, msg?: string }` successful operation
   */
  "/xy/console/console/sysConfig/task_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/console/sysConfig/task`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: { growth?: number; integral?: number }; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/console/sysConfig/groupCreationLevel
   * @summary 更新圈子创建等级配置
   * @tags 系统-配置管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/console/sysConfig/groupCreationLevel_PUT": (
    root: { code?: string; value?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysConfig/groupCreationLevel`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/console/sysConfig/groupCreationLevel
   * @summary 获取圈子创建等级配置
   * @tags 系统-配置管理
   * @response `200` `{ code?: number, data?: { code?: string, createUser?: string, enabled?: boolean, gmtCreated?: string, gmtModified?: string, id?: number, modifyUser?: string, name?: string, status?: number, value?: string }, msg?: string }` successful operation
   */
  "/xy/console/console/sysConfig/groupCreationLevel_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/console/sysConfig/groupCreationLevel`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        code?: string;
        createUser?: string;
        enabled?: boolean;
        gmtCreated?: string;
        gmtModified?: string;
        id?: number;
        modifyUser?: string;
        name?: string;
        status?: number;
        value?: string;
      };
      msg?: string;
    }>,
  /**
   * @description 请求示例 ``` [ { "day": 1, "integral": 1, "growth": 1 }, { "day": 2, "integral": 1, "growth": 1 }, { "day": 3, "integral": 1, "growth": 1 }, { "day": 4, "integral": 1, "growth": 1 }, { "day": 5, "integral": 1, "growth": 1 }, { "day": 6, "integral": 1, "growth": 1 }, { "day": 7, "integral": 1, "growth": 1 } ] ```
   * @name PUT /xy/console/console/sysConfig/sign
   * @summary 更新签到配置
   * @tags 系统-配置管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/console/sysConfig/sign_PUT": (
    root: { day?: number; growth?: number; integral?: number }[],
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysConfig/sign`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/console/sysConfig/sign
   * @summary 获取签到配置
   * @tags 系统-配置管理
   * @response `200` `{ code?: number, data?: ({ day?: number, growth?: number, integral?: number })[], msg?: string }` successful operation
   */
  "/xy/console/console/sysConfig/sign_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/console/sysConfig/sign`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: { day?: number; growth?: number; integral?: number }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name DELETE /xy/console/trial/{id}
   * @summary 删除活动
   * @tags 试用活动相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/trial/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/trial/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name POST /xy/console/trial/{id}
   * @summary 活动详情
   * @tags 试用活动相关接口
   * @response `200` `{ code?: number, data?: { activityImg?: string, activityName?: string, activityStatus?: number, applyBeginTime?: string, applyEndTime?: string, applyThresholdLevel?: (object)[], applyThresholdStatus?: boolean, feedbackNum?: number, goodsCoverImg?: string, goodsDetail?: { bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean }, goodsId?: number, goodsList?: ({ activityId?: number, delIs?: boolean, gmtCreate?: string, gmtModified?: string, goodsId?: number, goodsName?: string, goodsNo?: string, goodsPrice?: number, id?: number, skuId?: number, skuImg?: string, specName?: string, trialNumber?: number })[], goodsName?: string, goodsNum?: number, id?: number, indexStatus?: boolean, participateNum?: number, reportDeadline?: string, richText?: string, status?: boolean, winNum?: number }, msg?: string }` successful operation
   */
  "/xy/console/trial/{id}_POST": (id: string, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/trial/${id}`,
      method: "POST",
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        activityImg?: string;
        activityName?: string;
        activityStatus?: number;
        applyBeginTime?: string;
        applyEndTime?: string;
        applyThresholdLevel?: object[];
        applyThresholdStatus?: boolean;
        feedbackNum?: number;
        goodsCoverImg?: string;
        goodsDetail?: {
          bannerImgs?: string[];
          code?: string;
          coverImg?: string;
          detailDesc?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsPropertyList?: {
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            propName?: string;
            propertyValueList?: object[];
          }[];
          id?: number;
          integralIs?: boolean;
          name?: string;
          outerId?: string;
          salesVolume?: number;
          skuList?: {
            code?: string;
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            integral?: number;
            integralSalesVolume?: number;
            integralShelfIs?: boolean;
            integralStock?: number;
            outerId?: string;
            outerPrice?: number;
            price?: number;
            salesVolume?: number;
            shelfIs?: boolean;
            skuImg?: string;
            skuName?: string;
            specIds?: number[];
            specNames?: string[];
            stock?: number;
            version?: string;
          }[];
          stock?: number;
          trialIs?: boolean;
        };
        goodsId?: number;
        goodsList?: {
          activityId?: number;
          delIs?: boolean;
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          goodsName?: string;
          goodsNo?: string;
          goodsPrice?: number;
          id?: number;
          skuId?: number;
          skuImg?: string;
          specName?: string;
          trialNumber?: number;
        }[];
        goodsName?: string;
        goodsNum?: number;
        id?: number;
        indexStatus?: boolean;
        participateNum?: number;
        reportDeadline?: string;
        richText?: string;
        status?: boolean;
        winNum?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xy/console/trial
   * @summary 添加活动
   * @tags 试用活动相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/trial_POST": (
    root: {
      activityImg?: string;
      activityName?: string;
      applyBeginTime?: string;
      applyEndTime?: string;
      applyThresholdLevel?: object[];
      applyThresholdStatus: boolean;
      goodsCoverImg?: string;
      goodsId: number;
      goodsList?: {
        activityId?: number;
        delIs?: boolean;
        gmtCreate?: string;
        gmtModified?: string;
        goodsId?: number;
        goodsName?: string;
        goodsNo?: string;
        goodsPrice?: number;
        id?: number;
        skuId?: number;
        skuImg?: string;
        specName?: string;
        trialNumber?: number;
      }[];
      goodsName?: string;
      id?: number;
      reportDeadline?: string;
      richText?: string;
      status?: boolean;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/trial`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/trial
   * @summary 试用活动列表
   * @tags 试用活动相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ activityImg?: string, activityName?: string, activityStatus?: number, applyBeginTime?: string, applyEndTime?: string, applyThresholdLevel?: (object)[], applyThresholdStatus?: boolean, feedbackNum?: number, goodsCoverImg?: string, goodsDetail?: { bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean }, goodsId?: number, goodsList?: ({ activityId?: number, delIs?: boolean, gmtCreate?: string, gmtModified?: string, goodsId?: number, goodsName?: string, goodsNo?: string, goodsPrice?: number, id?: number, skuId?: number, skuImg?: string, specName?: string, trialNumber?: number })[], goodsName?: string, goodsNum?: number, id?: number, indexStatus?: boolean, participateNum?: number, reportDeadline?: string, richText?: string, status?: boolean, winNum?: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/trial_GET": (query: XyConsoleTrialGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/trial`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          activityImg?: string;
          activityName?: string;
          activityStatus?: number;
          applyBeginTime?: string;
          applyEndTime?: string;
          applyThresholdLevel?: object[];
          applyThresholdStatus?: boolean;
          feedbackNum?: number;
          goodsCoverImg?: string;
          goodsDetail?: {
            bannerImgs?: string[];
            code?: string;
            coverImg?: string;
            detailDesc?: string;
            gmtCreate?: string;
            gmtModified?: string;
            goodsPropertyList?: {
              gmtCreate?: string;
              gmtModified?: string;
              goodsId?: number;
              id?: number;
              propName?: string;
              propertyValueList?: object[];
            }[];
            id?: number;
            integralIs?: boolean;
            name?: string;
            outerId?: string;
            salesVolume?: number;
            skuList?: {
              code?: string;
              gmtCreate?: string;
              gmtModified?: string;
              goodsId?: number;
              id?: number;
              integral?: number;
              integralSalesVolume?: number;
              integralShelfIs?: boolean;
              integralStock?: number;
              outerId?: string;
              outerPrice?: number;
              price?: number;
              salesVolume?: number;
              shelfIs?: boolean;
              skuImg?: string;
              skuName?: string;
              specIds?: number[];
              specNames?: string[];
              stock?: number;
              version?: string;
            }[];
            stock?: number;
            trialIs?: boolean;
          };
          goodsId?: number;
          goodsList?: {
            activityId?: number;
            delIs?: boolean;
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            goodsName?: string;
            goodsNo?: string;
            goodsPrice?: number;
            id?: number;
            skuId?: number;
            skuImg?: string;
            specName?: string;
            trialNumber?: number;
          }[];
          goodsName?: string;
          goodsNum?: number;
          id?: number;
          indexStatus?: boolean;
          participateNum?: number;
          reportDeadline?: string;
          richText?: string;
          status?: boolean;
          winNum?: number;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xy/console/trial/indexStatus
   * @summary 设置首页是否显示
   * @tags 试用活动相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/trial/indexStatus_PUT": (root: { id?: number; status?: boolean }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/trial/indexStatus`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/trial/record
   * @summary 试用记录
   * @tags 试用活动相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ activityId?: number, activityName?: string, applyTime?: string, blackStatus?: boolean, feedbackContent?: string, feedbackEndTime?: string, feedbackImg?: (object)[], feedbackScore?: number, feedbackStatus?: boolean, feedbackSubmitTime?: string, goodsId?: number, goodsImg?: string, goodsName?: string, goodsNo?: string, id?: number, logisticsCompany?: string, logisticsNo?: string, pushStatus?: boolean, receiverAddress?: string, receiverName?: string, receiverPhone?: string, receiverStatus?: boolean, resultStatus?: boolean, skuId?: number, specName?: string, userId?: number, userMobile?: string, userName?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/trial/record_GET": (
    query: XyConsoleTrialRecordGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/trial/record`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          activityId?: number;
          activityName?: string;
          applyTime?: string;
          blackStatus?: boolean;
          feedbackContent?: string;
          feedbackEndTime?: string;
          feedbackImg?: object[];
          feedbackScore?: number;
          feedbackStatus?: boolean;
          feedbackSubmitTime?: string;
          goodsId?: number;
          goodsImg?: string;
          goodsName?: string;
          goodsNo?: string;
          id?: number;
          logisticsCompany?: string;
          logisticsNo?: string;
          pushStatus?: boolean;
          receiverAddress?: string;
          receiverName?: string;
          receiverPhone?: string;
          receiverStatus?: boolean;
          resultStatus?: boolean;
          skuId?: number;
          specName?: string;
          userId?: number;
          userMobile?: string;
          userName?: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xy/console/muteWords
   * @summary 创建敏感词
   * @tags 敏感词管理
   * @response `200` `{ code?: number, data?: { content: string, contentReplace: string, id: number }, msg?: string }` successful operation
   */
  "/xy/console/muteWords_POST": (root: { content: string; contentReplace: string }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/muteWords`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: { content: string; contentReplace: string; id: number };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/muteWords
   * @summary 搜索敏感词
   * @tags 敏感词管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ content: string, contentReplace: string, id: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/muteWords_GET": (query: XyConsoleMuteWordsGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/muteWords`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: { content: string; contentReplace: string; id: number }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name DELETE /xy/console/muteWords/{id}
   * @summary 删除敏感词
   * @tags 敏感词管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/muteWords/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/muteWords/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/muteWords/{id}
   * @summary 更新敏感词
   * @tags 敏感词管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/muteWords/{id}_PUT": (
    id: string,
    root: { content: string; contentReplace: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/muteWords/${id}`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/muteWords/{id}
   * @summary 详情
   * @tags 敏感词管理
   * @response `200` `{ code?: number, data?: { content: string, contentReplace: string, id: number }, msg?: string }` successful operation
   */
  "/xy/console/muteWords/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/muteWords/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: { content: string; contentReplace: string; id: number };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xy/console/live/status
   * @summary 修改直播状态
   * @tags 直播相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/live/status_PUT": (root: { id?: number; status?: boolean }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/live/status`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/live
   * @summary 查询直播列表
   * @tags 直播相关接口
   * @response `200` `{ code?: number, data?: ({ anchorImg?: string, anchorName?: string, homeImg?: string, id?: number, initialNumber?: number, introduction?: string, liveDesc?: string, liveName?: string, liveTime?: string, posterStatus?: boolean, promotionalVideo?: (object)[], status?: boolean, studioId?: number, studioName?: string, subscribeNum?: number, subscribeNumber?: number, trailerRich?: string })[], msg?: string }` successful operation
   */
  "/xy/console/live_GET": (query: XyConsoleLiveGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/live`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        anchorImg?: string;
        anchorName?: string;
        homeImg?: string;
        id?: number;
        initialNumber?: number;
        introduction?: string;
        liveDesc?: string;
        liveName?: string;
        liveTime?: string;
        posterStatus?: boolean;
        promotionalVideo?: object[];
        status?: boolean;
        studioId?: number;
        studioName?: string;
        subscribeNum?: number;
        subscribeNumber?: number;
        trailerRich?: string;
      }[];
      msg?: string;
    }>,
          /**
   * No description
   * @name PUT /community/console/live
   * @summary 新增直播
   * @tags 直播相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/live_POST": (
    root: {
      anchorImg: string;
      anchorName: string;
      homeImg: string;
      id?: number;
      initialNumber?: number;
      introduction: string;
      liveDesc: string;
      liveName: string;
      promotionalVideo: object[];
      trailerRich?: string;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/live`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/live
   * @summary 编辑直播
   * @tags 直播相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/live_PUT": (
    root: {
      anchorImg: string;
      anchorName: string;
      homeImg: string;
      id?: number;
      initialNumber?: number;
      introduction: string;
      liveDesc: string;
      liveName: string;
      promotionalVideo: object[];
      trailerRich?: string;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/live`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/live/{id}
   * @summary 查询直播详情
   * @tags 直播相关接口
   * @response `200` `{ code?: number, data?: { anchorImg?: string, anchorName?: string, homeImg?: string, id?: number, initialNumber?: number, introduction?: string, liveDesc?: string, liveName?: string, liveTime?: string, posterStatus?: boolean, promotionalVideo?: (object)[], status?: boolean, studioId?: number, studioName?: string, subscribeNum?: number, subscribeNumber?: number, trailerRich?: string }, msg?: string }` successful operation
   */
  "/xy/console/live/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/live/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        anchorImg?: string;
        anchorName?: string;
        homeImg?: string;
        id?: number;
        initialNumber?: number;
        introduction?: string;
        liveDesc?: string;
        liveName?: string;
        liveTime?: string;
        posterStatus?: boolean;
        promotionalVideo?: object[];
        status?: boolean;
        studioId?: number;
        studioName?: string;
        subscribeNum?: number;
        subscribeNumber?: number;
        trailerRich?: string;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/oss/policy
   * @summary 获取OSS临时凭证
   * @tags oss-console-controller
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/oss/policy_GET": (
    query: XyConsoleOssPolicyGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/oss/policy`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/tags/tags4groups
   * @summary 为圈子添加tag
   * @tags 标签-标签管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/tags/tags4groups_PUT": (
    root: { groupIds?: number[]; tagIds?: number[] },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/tags/tags4groups`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/tags/tags4users
   * @summary 为用户添加tag
   * @tags 标签-标签管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/tags/tags4users_PUT": (
    root: { tagIds?: number[]; userIds?: number[] },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/tags/tags4users`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/tags/{id}
   * @summary 修改标签
   * @tags 标签-标签管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/tags/{id}_PUT": (
    id: string,
    root: { categoryId?: number; enabled?: boolean; groupCnt?: number; id: number; memberCnt: number; name: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/tags/${id}`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name DELETE /xy/console/tags/{id}
   * @summary 删除标签
   * @tags 标签-标签管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/tags/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/tags/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/tags/enable
   * @summary 启用/禁用标签
   * @tags 标签-标签管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/tags/enable_PUT": (root: { decision?: boolean; id?: number }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/tags/enable`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/tags
   * @summary 搜索标签
   * @tags 标签-标签管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ categoryId: number, categoryName: string, enabled: boolean, groupCnt: number, id: number, memberCnt: number, name: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/tags_GET": (query: XyConsoleTagsGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/tags`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          categoryId: number;
          categoryName: string;
          enabled: boolean;
          groupCnt: number;
          id: number;
          memberCnt: number;
          name: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xy/console/tags
   * @summary 标签创建
   * @tags 标签-标签管理
   * @response `200` `{ code?: number, data?: { categoryId: number, categoryName: string, enabled: boolean, groupCnt: number, id: number, memberCnt: number, name: string }, msg?: string }` successful operation
   */
  "/xy/console/tags_POST": (
    root: { categoryId?: number; enabled?: boolean; groupCnt?: number; id: number; memberCnt: number; name: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/tags`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        categoryId: number;
        categoryName: string;
        enabled: boolean;
        groupCnt: number;
        id: number;
        memberCnt: number;
        name: string;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xy/console/tagCategories/{id}
   * @summary 修改标签分组
   * @tags 标签分组管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/tagCategories/{id}_PUT": (id: string, root: { name: string }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/tagCategories/${id}`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name DELETE /xy/console/tagCategories/{id}
   * @summary 删除标签分组
   * @tags 标签分组管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/tagCategories/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/tagCategories/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/tagCategories
   * @summary 所有标签分组
   * @tags 标签分组管理
   * @response `200` `{ code?: number, data?: ({ id: number, name: string })[], msg?: string }` successful operation
   */
  "/xy/console/tagCategories_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/tagCategories`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: { id: number; name: string }[]; msg?: string }>,
  /**
   * No description
   * @name POST /xy/console/tagCategories
   * @summary 标签分组创建
   * @tags 标签分组管理
   * @response `200` `{ code?: number, data?: { id: number, name: string }, msg?: string }` successful operation
   */
  "/xy/console/tagCategories_POST": (root: { name: string }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/tagCategories`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: { id: number; name: string }; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/workOrder
   * @summary 工单列表
   * @tags 工单-问题反馈接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ auditStatus?: number, content?: string, disposeTime?: string, gaiaAuditTime?: string, gaiaStatus?: number, gaiaUser?: string, gmtCreate?: string, gmtModified?: string, id?: number, imgUrl?: (object)[], sysAuditContent?: string, sysAuditImg?: (object)[], sysAuditTime?: string, sysAuditUser?: string, sysAuditUserId?: number, type?: number, userId?: number, userMobile?: string, userName?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/workOrder_GET": (query: XyConsoleWorkOrderGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/workOrder`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          auditStatus?: number;
          content?: string;
          disposeTime?: string;
          gaiaAuditTime?: string;
          gaiaStatus?: number;
          gaiaUser?: string;
          gmtCreate?: string;
          gmtModified?: string;
          id?: number;
          imgUrl?: object[];
          sysAuditContent?: string;
          sysAuditImg?: object[];
          sysAuditTime?: string;
          sysAuditUser?: string;
          sysAuditUserId?: number;
          type?: number;
          userId?: number;
          userMobile?: string;
          userName?: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xy/console/workOrder
   * @summary 平台审核
   * @tags 工单-问题反馈接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/workOrder_POST": (
    root: { id: number; pushStatus: boolean; sysAuditContent?: string; sysAuditImg?: object[] },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/workOrder`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/workOrder/{id}
   * @summary 工单详情
   * @tags 工单-问题反馈接口
   * @response `200` `{ code?: number, data?: { auditStatus?: number, content?: string, disposeTime?: string, gaiaAuditTime?: string, gaiaStatus?: number, gaiaUser?: string, gmtCreate?: string, gmtModified?: string, id?: number, imgUrl?: (object)[], sysAuditContent?: string, sysAuditImg?: (object)[], sysAuditTime?: string, sysAuditUser?: string, sysAuditUserId?: number, type?: number, userId?: number, userMobile?: string, userName?: string }, msg?: string }` successful operation
   */
  "/xy/console/workOrder/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/workOrder/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        auditStatus?: number;
        content?: string;
        disposeTime?: string;
        gaiaAuditTime?: string;
        gaiaStatus?: number;
        gaiaUser?: string;
        gmtCreate?: string;
        gmtModified?: string;
        id?: number;
        imgUrl?: object[];
        sysAuditContent?: string;
        sysAuditImg?: object[];
        sysAuditTime?: string;
        sysAuditUser?: string;
        sysAuditUserId?: number;
        type?: number;
        userId?: number;
        userMobile?: string;
        userName?: string;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/workOrder/{id}/confirm
   * @summary 盖亚审核后的最终确认
   * @tags 工单-问题反馈接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/workOrder/{id}/confirm_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/workOrder/${id}/confirm`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name DELETE /xy/console/topics/{id}
   * @summary 删除话题
   * @tags 话题相关接口
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/topics/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/topics/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/topics
   * @summary 搜索话题列表
   * @tags 话题相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ enabled: boolean, hot: boolean, id: number, mentionCnt: number, name: string, sortNum: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/topics_GET": (query: XyConsoleTopicsGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/topics`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: { enabled: boolean; hot: boolean; id: number; mentionCnt: number; name: string; sortNum: number }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xy/console/public/jstDeliver
   * @summary jstDeliver
   * @tags 公开访问的APIs
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/public/jstDeliver_POST": (
    query: XyConsolePublicJstDeliverPostParams,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/public/jstDeliver`,
      method: "POST",
      params: query,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name POST /xy/console/public/forgot
   * @summary 忘记密码
   * @tags 公开访问的APIs
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/public/forgot_POST": (
    root: { code?: string; mobile?: string; password?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/public/forgot`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name POST /xy/console/public/register
   * @summary 注册（返回token）
   * @tags 公开访问的APIs
   * @response `200` `{ code?: number, data?: string, msg?: string }` successful operation
   */
  "/xy/console/public/register_POST": (
    root: { code?: string; mobile?: string; password?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/public/register`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: string; msg?: string }>,
  /**
   * No description
   * @name POST /xy/console/public/login
   * @summary 登录
   * @tags 公开访问的APIs
   * @response `200` `{ code?: number, data?: string, msg?: string }` successful operation
   */
  "/xy/console/public/login_POST": (
    root: { agent?: string; loginIp?: string; mobile?: string; password?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/public/login`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: string; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/groupApproves
   * @summary 审批操作
   * @tags 圈子-圈子审批
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/groupApproves_PUT": (
    root: { approveId: number; approverId?: number; memo?: string; status: "APPROVED" | "CREATED" | "REJECTED" },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/groupApproves`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/groupApproves
   * @summary 搜索审批列表
   * @tags 圈子-圈子审批
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ applicantId: number, applyTime: string, approveTime: string, approverId?: number, creatorMobile: string, creatorNickname: string, enumStatus: number, groupId: number, id: number, leastLevel: number, name: string, subTitle: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/groupApproves_GET": (
    query: XyConsoleGroupApprovesGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/groupApproves`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          applicantId: number;
          applyTime: string;
          approveTime: string;
          approverId?: number;
          creatorMobile: string;
          creatorNickname: string;
          enumStatus: number;
          groupId: number;
          id: number;
          leastLevel: number;
          name: string;
          subTitle: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name DELETE /xy/console/problemClassify/{id}
   * @summary 删除问题分类
   * @tags 问题分类
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/problemClassify/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/problemClassify/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * @description ### 请求示例 ``` { "status": true, "name": "问题分类" } ```
   * @name POST /xy/console/problemClassify
   * @summary 新增问题分类
   * @tags 问题分类
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/problemClassify_POST": (
    root: { id?: number; name: string; status: boolean },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/problemClassify`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/problemClassify
   * @summary 查询全部问题分类
   * @tags 问题分类
   * @response `200` `{ code?: number, data?: ({ id?: number, name?: string, sort?: number, status?: boolean })[], msg?: string }` successful operation
   */
  "/xy/console/problemClassify_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/problemClassify`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: { id?: number; name?: string; sort?: number; status?: boolean }[];
      msg?: string;
    }>,
  /**
   * @description ### 请求示例 ``` { "status": true, "id": 3, "name": "问题分类3" } ```
   * @name PUT /xy/console/problemClassify
   * @summary 编辑问题分类
   * @tags 问题分类
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/problemClassify_PUT": (
    root: { id?: number; name: string; status: boolean },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/problemClassify`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name DELETE /xy/console/problem/{id}
   * @summary 删除常见问题
   * @tags 常见问题
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/problem/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/problem/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/problem/{id}
   * @summary 查询常见问题
   * @tags 常见问题
   * @response `200` `{ code?: number, data?: { answer?: string, classifyId?: number, id?: number, sort?: number, status?: boolean, title?: string }, msg?: string }` successful operation
   */
  "/xy/console/problem/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/problem/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: { answer?: string; classifyId?: number; id?: number; sort?: number; status?: boolean; title?: string };
      msg?: string;
    }>,
  /**
   * @description ### 请求示例 ``` { "classifyId": 1, "sort": 1, "status": false, "title": "问题标题1", "answer": "答案富文本" } ```
   * @name POST /xy/console/problem
   * @summary 新增常见问题
   * @tags 常见问题
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/problem_POST": (
    root: { answer?: string; classifyId: number; id?: number; sort: number; status: boolean; title: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/problem`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/problem
   * @summary 查询常见问题
   * @tags 常见问题
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ answer?: string, classifyId?: number, id?: number, sort?: number, status?: boolean, title?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/problem_GET": (query: XyConsoleProblemGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/problem`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: { answer?: string; classifyId?: number; id?: number; sort?: number; status?: boolean; title?: string }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * @description ### 请求示例 ``` { "id":3, "classifyId": 1, "sort": 4, "status": true, "title": "问题标题3", "answer": "答案富文本" } ```
   * @name PUT /xy/console/problem
   * @summary 编辑常见问题
   * @tags 常见问题
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/problem_PUT": (
    root: { answer?: string; classifyId: number; id?: number; sort: number; status: boolean; title: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/problem`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/problem/status
   * @summary 更改问题状态
   * @tags 常见问题
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/problem/status_PUT": (root: { id?: number; status?: boolean }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/problem/status`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/user/cancelGroupCreator
   * @summary 批量将用户撤销白名单圈主
   * @tags 用户-用户信息相关接口
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/user/cancelGroupCreator_PUT": (root: number[], options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/user/cancelGroupCreator`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/user/groupCreator
   * @summary 批量将用户设置为白名单圈主
   * @tags 用户-用户信息相关接口
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/user/groupCreator_PUT": (root: number[], options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/user/groupCreator`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * @description ##
   * @name GET /xy/console/user
   * @summary 用户列表查询(包含圈主白名单用户列表查询)
   * @tags 用户-用户信息相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ address?: { address?: string, city?: string, district?: string, gmtCreate?: string, id?: number, isDefault?: boolean, mobile?: string, name?: string, province?: string, userId?: number }, birthday?: string, family?: { boyBirthday?: (object)[], boyNum?: number, elderNum?: number, girlBirthday?: (object)[], girlNum?: number, id?: number, userId?: number }, groupCreator?: boolean, groupCreatorTime?: string, growth?: number, headImgUrl?: string, historyIntegral?: number, id?: number, integral?: number, level?: number, mail?: string, mobile?: string, nextGrowth?: number, nickname?: string, openid?: string, registerDate?: string, sex?: number, status?: boolean, tagList?: ({ gmtCreate?: string, id?: number, tagId?: number, tagName?: string, userId?: number })[] })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/user_GET": (query: XyConsoleUserGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/user`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          address?: {
            address?: string;
            city?: string;
            district?: string;
            gmtCreate?: string;
            id?: number;
            isDefault?: boolean;
            mobile?: string;
            name?: string;
            province?: string;
            userId?: number;
          };
          birthday?: string;
          family?: {
            boyBirthday?: object[];
            boyNum?: number;
            elderNum?: number;
            girlBirthday?: object[];
            girlNum?: number;
            id?: number;
            userId?: number;
          };
          groupCreator?: boolean;
          groupCreatorTime?: string;
          growth?: number;
          headImgUrl?: string;
          historyIntegral?: number;
          id?: number;
          integral?: number;
          level?: number;
          mail?: string;
          mobile?: string;
          nextGrowth?: number;
          nickname?: string;
          openid?: string;
          registerDate?: string;
          sex?: number;
          status?: boolean;
          tagList?: { gmtCreate?: string; id?: number; tagId?: number; tagName?: string; userId?: number }[];
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xy/console/user
   * @summary 用户状态修改
   * @tags 用户-用户信息相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/user_PUT": (root: { id?: number; status?: boolean }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/user`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * @description ## 返回示例 ``` { "code": 0, "msg": "OK", "data": { "id": 3, "nickname": "昵称", "mobile": "18505452704", "headImgUrl": "https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83epo40KyxqJDRN1cykS8VGiaSyoc1HZquG3PTAp2zlwd6l4sKIp4nJjia2WKnPOovxKt3icj1B2vfINtA/132", "sex": 0, "registerDate": 1637486177000, "integral": 0, "historyIntegral": 0, "growth": 0, "level": 3, "address": { "id": 1, "userId": 3, "name": "姓名", "mobile": "123456", "province": "省", "city": "市", "district": "区", "address": "详细", "isDefault": true, "gmtCreate": 1637119766000 }, "status": true } } ```
   * @name GET /xy/console/user/{id}
   * @summary 用户详情
   * @tags 用户-用户信息相关接口
   * @response `200` `{ code?: number, data?: { address?: { address?: string, city?: string, district?: string, gmtCreate?: string, id?: number, isDefault?: boolean, mobile?: string, name?: string, province?: string, userId?: number }, birthday?: string, family?: { boyBirthday?: (object)[], boyNum?: number, elderNum?: number, girlBirthday?: (object)[], girlNum?: number, id?: number, userId?: number }, groupCreator?: boolean, groupCreatorTime?: string, growth?: number, headImgUrl?: string, historyIntegral?: number, id?: number, integral?: number, level?: number, mail?: string, mobile?: string, nextGrowth?: number, nickname?: string, openid?: string, registerDate?: string, sex?: number, status?: boolean, tagList?: ({ gmtCreate?: string, id?: number, tagId?: number, tagName?: string, userId?: number })[] }, msg?: string }` successful operation
   */
  "/xy/console/user/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/user/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        address?: {
          address?: string;
          city?: string;
          district?: string;
          gmtCreate?: string;
          id?: number;
          isDefault?: boolean;
          mobile?: string;
          name?: string;
          province?: string;
          userId?: number;
        };
        birthday?: string;
        family?: {
          boyBirthday?: object[];
          boyNum?: number;
          elderNum?: number;
          girlBirthday?: object[];
          girlNum?: number;
          id?: number;
          userId?: number;
        };
        groupCreator?: boolean;
        groupCreatorTime?: string;
        growth?: number;
        headImgUrl?: string;
        historyIntegral?: number;
        id?: number;
        integral?: number;
        level?: number;
        mail?: string;
        mobile?: string;
        nextGrowth?: number;
        nickname?: string;
        openid?: string;
        registerDate?: string;
        sex?: number;
        status?: boolean;
        tagList?: { gmtCreate?: string; id?: number; tagId?: number; tagName?: string; userId?: number }[];
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/user/simple
   * @summary 简单搜索
   * @tags 用户-用户信息相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ id?: number, mobile?: string, nickname?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/user/simple_GET": (
    query: XyConsoleUserSimpleGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/user/simple`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: { id?: number; mobile?: string; nickname?: string }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xy/console/userLevel
   * @summary 新增等级
   * @tags 用户-用户等级信息相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/userLevel_POST": (
    root: { gmtCreate?: string; gmtModified?: string; growthValue?: number; id?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/userLevel`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/userLevel
   * @summary 用户等级列表查询
   * @tags 用户-用户等级信息相关接口
   * @response `200` `{ code?: number, data?: ({ growthValue?: number, id?: number })[], msg?: string }` successful operation
   */
  "/xy/console/userLevel_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/userLevel`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: { growthValue?: number; id?: number }[]; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/userLevel
   * @summary 编辑等级
   * @tags 用户-用户等级信息相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/userLevel_PUT": (
    root: { gmtCreate?: string; gmtModified?: string; growthValue?: number; id?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/userLevel`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/userGrowthRecord
   * @summary 查询用户成长值记录
   * @tags 用户成长值记录相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ changeValue?: number, gmtCreate?: string, id?: number, remark?: string, submitTime?: string, sysSubmitUser?: string, sysSubmitUserId?: number, type?: number, userId?: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/userGrowthRecord_GET": (
    query: XyConsoleUserGrowthRecordGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/userGrowthRecord`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          changeValue?: number;
          gmtCreate?: string;
          id?: number;
          remark?: string;
          submitTime?: string;
          sysSubmitUser?: string;
          sysSubmitUserId?: number;
          type?: number;
          userId?: number;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xy/console/userGrowthRecord/adjust
   * @summary 调整用户成长值
   * @tags 用户成长值记录相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/userGrowthRecord/adjust_POST": (
    root: { changeValue: number; type: number; userId?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/userGrowthRecord/adjust`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name POST /xy/console/userIntegralRecord/audit
   * @summary 二次审核
   * @tags 用户积分记录相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/userIntegralRecord/audit_POST": (
    root: { auditStatus: boolean; id: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/userIntegralRecord/audit`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/userIntegralRecord/audit
   * @summary 二次审核人员查询用户积分记录
   * @tags 用户积分记录相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ auditStatus?: number, auditTime?: string, changeTime?: string, changeType?: number, changeValue?: number, gmtCreate?: string, id?: number, remark?: string, submitTime?: string, sysAuditUser?: string, sysAuditUserId?: number, sysSubmitUser?: string, sysSubmitUserId?: number, type?: number, userId?: number, userMobile?: string, userName?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/userIntegralRecord/audit_GET": (
    query: XyConsoleUserIntegralRecordAuditGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/userIntegralRecord/audit`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          auditStatus?: number;
          auditTime?: string;
          changeTime?: string;
          changeType?: number;
          changeValue?: number;
          gmtCreate?: string;
          id?: number;
          remark?: string;
          submitTime?: string;
          sysAuditUser?: string;
          sysAuditUserId?: number;
          sysSubmitUser?: string;
          sysSubmitUserId?: number;
          type?: number;
          userId?: number;
          userMobile?: string;
          userName?: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * @description ## 返回示例 ``` { "code": 0, "msg": "OK", "data": { "pageNum": 1, "pageSize": 1, "size": 1, "startRow": 0, "endRow": 0, "total": 1, "pages": 1, "list": [ { "id": 1, "changeValue": 100, "type": 1, "remark": "增加积分", "changeTime": 1637506554000 } ], "prePage": 0, "nextPage": 0, "isFirstPage": true, "isLastPage": true, "hasPreviousPage": false, "hasNextPage": false, "navigatePages": 8, "navigatepageNums": [ 1 ], "navigateFirstPage": 1, "navigateLastPage": 1, "firstPage": 1, "lastPage": 1 } } ```
   * @name GET /xy/console/userIntegralRecord
   * @summary 查询用户积分记录
   * @tags 用户积分记录相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ auditStatus?: number, auditTime?: string, changeTime?: string, changeType?: number, changeValue?: number, gmtCreate?: string, id?: number, remark?: string, submitTime?: string, sysAuditUser?: string, sysAuditUserId?: number, sysSubmitUser?: string, sysSubmitUserId?: number, type?: number, userId?: number, userMobile?: string, userName?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/userIntegralRecord_GET": (
    query: XyConsoleUserIntegralRecordGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/userIntegralRecord`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          auditStatus?: number;
          auditTime?: string;
          changeTime?: string;
          changeType?: number;
          changeValue?: number;
          gmtCreate?: string;
          id?: number;
          remark?: string;
          submitTime?: string;
          sysAuditUser?: string;
          sysAuditUserId?: number;
          sysSubmitUser?: string;
          sysSubmitUserId?: number;
          type?: number;
          userId?: number;
          userMobile?: string;
          userName?: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * @description ## 请求示例 ``` { "changeValue": 50, "remark": "remark", "userId": 3, "type": 1 } ```
   * @name POST /xy/console/userIntegralRecord/adjust
   * @summary 调整用户积分
   * @tags 用户积分记录相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/userIntegralRecord/adjust_POST": (
    root: { changeValue?: number; remark?: string; type?: number; userId?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/userIntegralRecord/adjust`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/userInvitedRecord
   * @summary 查询用户邀请好友记录
   * @tags 用户邀请记录相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ beInviterUserId?: number, beInviterUserMobile?: string, beInviterUserName?: string, gmtCreate?: string, id?: number, userId?: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/userInvitedRecord_GET": (
    query: XyConsoleUserInvitedRecordGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/userInvitedRecord`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          beInviterUserId?: number;
          beInviterUserMobile?: string;
          beInviterUserName?: string;
          gmtCreate?: string;
          id?: number;
          userId?: number;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xy/console/console/sysUser/roles-user
   * @summary 保存员工与角色的对应关系
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/console/sysUser/roles-user_POST": (
    root: { roleIds?: number[]; userId?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysUser/roles-user`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/console/sysUser/update
   * @summary 员工修改
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/console/sysUser/update_PUT": (
    root: { deptIds?: string; email?: string; id?: number; mobile?: string; roleIds?: number[]; username?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysUser/update`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name DELETE /xy/console/console/sysUser/delete
   * @summary 员工删除
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/console/sysUser/delete_DELETE": (
    query: XyConsoleConsoleSysUserDeleteDeleteParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysUser/delete`,
      method: "DELETE",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name POST /xy/console/console/sysUser/add
   * @summary 员工新增(返回ID)
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, data?: number, msg?: string }` successful operation
   */
  "/xy/console/console/sysUser/add_POST": (
    root: { deptIds?: string; email?: string; id?: number; mobile?: string; roleIds?: number[]; username?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysUser/add`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/console/sysUser/query
   * @summary 员工表分页查询
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ deptIds?: string, deptNames?: string, email?: string, gmtCreated?: string, gmtModified?: string, id?: number, mobile?: string, roleIds?: string, roleNames?: string, username?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/console/sysUser/query_GET": (
    query: XyConsoleConsoleSysUserQueryGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysUser/query`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          deptIds?: string;
          deptNames?: string;
          email?: string;
          gmtCreated?: string;
          gmtModified?: string;
          id?: number;
          mobile?: string;
          roleIds?: string;
          roleNames?: string;
          username?: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/console/sysUser/{id}/roles
   * @summary 根据员工ID查询员工关联的角色集合
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, data?: ({ authority?: string, createUser?: string, description?: string, gmtCreated?: string, gmtModified?: string, id?: number, modifyUser?: string, roleName?: string, status?: number })[], msg?: string }` successful operation
   */
  "/xy/console/console/sysUser/{id}/roles_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/console/sysUser/${id}/roles`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        authority?: string;
        createUser?: string;
        description?: string;
        gmtCreated?: string;
        gmtModified?: string;
        id?: number;
        modifyUser?: string;
        roleName?: string;
        status?: number;
      }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/console/sysUser/{id}/resources
   * @summary 根据员工ID获取员工可访问的资源
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, data?: ({ code?: string, createUser?: string, gmtCreated?: string, gmtModified?: string, icon?: string, id?: number, memo?: string, method?: string, modifyUser?: string, name?: string, parentId?: number, path?: string, sortNum?: number, status?: number, type?: number, visible?: boolean })[], msg?: string }` successful operation
   */
  "/xy/console/console/sysUser/{id}/resources_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/console/sysUser/${id}/resources`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        code?: string;
        createUser?: string;
        gmtCreated?: string;
        gmtModified?: string;
        icon?: string;
        id?: number;
        memo?: string;
        method?: string;
        modifyUser?: string;
        name?: string;
        parentId?: number;
        path?: string;
        sortNum?: number;
        status?: number;
        type?: number;
        visible?: boolean;
      }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/console/sysUser/current-authorities
   * @summary 获取当前用户权限
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, data?: { apis?: (object)[], buttons?: (string)[], email?: string, menusTree?: ({ children?: (any)[], detail?: object, id?: number, key?: string, parentId?: number, sortNum?: number, title?: string })[], username?: string }, msg?: string }` successful operation
   */
  "/xy/console/console/sysUser/current-authorities_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/console/sysUser/current-authorities`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        apis?: object[];
        buttons?: string[];
        email?: string;
        menusTree?: {
          children?: any[];
          detail?: object;
          id?: number;
          key?: string;
          parentId?: number;
          sortNum?: number;
          title?: string;
        }[];
        username?: string;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name DELETE /xy/console/console/sysUser/resetDefault
   * @summary 重置密码
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/console/sysUser/resetDefault_DELETE": (
    query: XyConsoleConsoleSysUserResetDefaultDeleteParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysUser/resetDefault`,
      method: "DELETE",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/console/sysUser/resetPwd
   * @summary 重置密码
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/console/sysUser/resetPwd_PUT": (
    root: { newPassword?: string; password?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysUser/resetPwd`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/console/sysDept/update
   * @summary 部门修改
   * @tags 系统-组织机构管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/console/sysDept/update_PUT": (
    root: { id?: number; name?: string; pid?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysDept/update`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name DELETE /xy/console/console/sysDept/delete
   * @summary 部门删除
   * @tags 系统-组织机构管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/console/sysDept/delete_DELETE": (
    query: XyConsoleConsoleSysDeptDeleteDeleteParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysDept/delete`,
      method: "DELETE",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name POST /xy/console/console/sysDept/add
   * @summary 部门新增(返回ID)
   * @tags 系统-组织机构管理
   * @response `200` `{ code?: number, data?: number, msg?: string }` successful operation
   */
  "/xy/console/console/sysDept/add_POST": (
    root: { id?: number; name?: string; pid?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysDept/add`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/console/sysDept/queryAll
   * @summary 部门表不分页查询
   * @tags 系统-组织机构管理
   * @response `200` `{ code?: number, data?: ({ children?: (any)[], gmtCreated?: string, id?: number, name?: string, pid?: number, userNum?: number })[], msg?: string }` successful operation
   */
  "/xy/console/console/sysDept/queryAll_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/console/sysDept/queryAll`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: { children?: any[]; gmtCreated?: string; id?: number; name?: string; pid?: number; userNum?: number }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/console/sysDept/queryAllHaveUser
   * @summary 部门表不分页查询（包含员工信息）
   * @tags 系统-组织机构管理
   * @response `200` `{ code?: number, data?: ({ children?: ({ children?: (any)[], gmtCreated?: string, id?: number, name?: string, pid?: number, userNum?: number })[], gmtCreated?: string, id?: number, name?: string, pid?: number, userList?: ({ deptIds?: string, deptNames?: string, email?: string, gmtCreated?: string, gmtModified?: string, id?: number, mobile?: string, roleIds?: string, roleNames?: string, username?: string })[], userNum?: number })[], msg?: string }` successful operation
   */
  "/xy/console/console/sysDept/queryAllHaveUser_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/console/sysDept/queryAllHaveUser`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        children?: {
          children?: any[];
          gmtCreated?: string;
          id?: number;
          name?: string;
          pid?: number;
          userNum?: number;
        }[];
        gmtCreated?: string;
        id?: number;
        name?: string;
        pid?: number;
        userList?: {
          deptIds?: string;
          deptNames?: string;
          email?: string;
          gmtCreated?: string;
          gmtModified?: string;
          id?: number;
          mobile?: string;
          roleIds?: string;
          roleNames?: string;
          username?: string;
        }[];
        userNum?: number;
      }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/console/sysDept/query
   * @summary 部门表分页查询
   * @tags 系统-组织机构管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ children?: (any)[], gmtCreated?: string, id?: number, name?: string, pid?: number, userNum?: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/console/sysDept/query_GET": (
    query: XyConsoleConsoleSysDeptQueryGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysDept/query`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: { children?: any[]; gmtCreated?: string; id?: number; name?: string; pid?: number; userNum?: number }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xy/console/console/sysRole/update
   * @summary 修改角色
   * @tags 系统-角色管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/console/sysRole/update_PUT": (
    root: { authority?: string; description?: string; id?: number; resourceIds?: number[]; roleName?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysRole/update`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name POST /xy/console/console/sysRole/resources-role
   * @summary 批量保存角色和资源的对应关系
   * @tags 系统-角色管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/console/sysRole/resources-role_POST": (
    root: { resourceIds?: number[]; roleId?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysRole/resources-role`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name POST /xy/console/console/sysRole/add
   * @summary 新增角色(返回ID)
   * @tags 系统-角色管理
   * @response `200` `{ code?: number, data?: number, msg?: string }` successful operation
   */
  "/xy/console/console/sysRole/add_POST": (
    root: { authority?: string; description?: string; id?: number; resourceIds?: number[]; roleName?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysRole/add`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/console/sysRole/{id}/resources
   * @summary 获取角色对应的资源集合
   * @tags 系统-角色管理
   * @response `200` `{ code?: number, data?: ({ code?: string, createUser?: string, gmtCreated?: string, gmtModified?: string, icon?: string, id?: number, memo?: string, method?: string, modifyUser?: string, name?: string, parentId?: number, path?: string, sortNum?: number, status?: number, type?: number, visible?: boolean })[], msg?: string }` successful operation
   */
  "/xy/console/console/sysRole/{id}/resources_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/console/sysRole/${id}/resources`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        code?: string;
        createUser?: string;
        gmtCreated?: string;
        gmtModified?: string;
        icon?: string;
        id?: number;
        memo?: string;
        method?: string;
        modifyUser?: string;
        name?: string;
        parentId?: number;
        path?: string;
        sortNum?: number;
        status?: number;
        type?: number;
        visible?: boolean;
      }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name DELETE /xy/console/console/sysRole/delete
   * @summary 角色删除
   * @tags 系统-角色管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/console/sysRole/delete_DELETE": (
    query: XyConsoleConsoleSysRoleDeleteDeleteParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysRole/delete`,
      method: "DELETE",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/console/sysRole/queryAll
   * @summary 角色表不分页查询
   * @tags 系统-角色管理
   * @response `200` `{ code?: number, data?: ({ authority?: string, description?: string, gmtCreated?: string, gmtModified?: string, id?: number, roleName?: string, userNum?: number })[], msg?: string }` successful operation
   */
  "/xy/console/console/sysRole/queryAll_GET": (
    query: XyConsoleConsoleSysRoleQueryAllGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysRole/queryAll`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        authority?: string;
        description?: string;
        gmtCreated?: string;
        gmtModified?: string;
        id?: number;
        roleName?: string;
        userNum?: number;
      }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/console/sysRole/query
   * @summary 角色表分页查询
   * @tags 系统-角色管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ authority?: string, description?: string, gmtCreated?: string, gmtModified?: string, id?: number, roleName?: string, userNum?: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/console/sysRole/query_GET": (
    query: XyConsoleConsoleSysRoleQueryGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysRole/query`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          authority?: string;
          description?: string;
          gmtCreated?: string;
          gmtModified?: string;
          id?: number;
          roleName?: string;
          userNum?: number;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/console/sysRole/{id}
   * @summary 详情
   * @tags 系统-角色管理
   * @response `200` `{ code?: number, data?: { apiIds?: (number)[], authority?: string, buttonIds?: (number)[], description?: string, gmtCreated?: string, gmtModified?: string, id?: number, menuIds?: (number)[], roleName?: string, userNum?: number }, msg?: string }` successful operation
   */
  "/xy/console/console/sysRole/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/console/sysRole/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        apiIds?: number[];
        authority?: string;
        buttonIds?: number[];
        description?: string;
        gmtCreated?: string;
        gmtModified?: string;
        id?: number;
        menuIds?: number[];
        roleName?: string;
        userNum?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xy/console/console/sysResource
   * @summary 修改
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: string, msg?: string }` successful operation
   */
  "/xy/console/console/sysResource_PUT": (
    root: {
      code?: string;
      createUser?: string;
      gmtCreated?: string;
      gmtModified?: string;
      icon?: string;
      id?: number;
      memo?: string;
      method?: string;
      modifyUser?: string;
      name?: string;
      parentId?: number;
      path?: string;
      sortNum?: number;
      status?: number;
      type?: number;
      visible?: boolean;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysResource`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: string; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/console/sysResource
   * @summary 搜索资源
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ code?: string, createUser?: string, gmtCreated?: string, gmtModified?: string, icon?: string, id?: number, memo?: string, method?: string, modifyUser?: string, name?: string, parentId?: number, path?: string, sortNum?: number, status?: number, type?: number, visible?: boolean })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/console/sysResource_GET": (
    query: XyConsoleConsoleSysResourceGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysResource`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          code?: string;
          createUser?: string;
          gmtCreated?: string;
          gmtModified?: string;
          icon?: string;
          id?: number;
          memo?: string;
          method?: string;
          modifyUser?: string;
          name?: string;
          parentId?: number;
          path?: string;
          sortNum?: number;
          status?: number;
          type?: number;
          visible?: boolean;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xy/console/console/sysResource
   * @summary 新增
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: string, msg?: string }` successful operation
   */
  "/xy/console/console/sysResource_POST": (
    root: {
      code?: string;
      createUser?: string;
      gmtCreated?: string;
      gmtModified?: string;
      icon?: string;
      id?: number;
      memo?: string;
      method?: string;
      modifyUser?: string;
      name?: string;
      parentId?: number;
      path?: string;
      sortNum?: number;
      status?: number;
      type?: number;
      visible?: boolean;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysResource`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: string; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/console/sysResource/{id}
   * @summary 修改
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: string, msg?: string }` successful operation
   */
  "/xy/console/console/sysResource/{id}_PUT": (
    id: string,
    root: {
      code?: string;
      createUser?: string;
      gmtCreated?: string;
      gmtModified?: string;
      icon?: string;
      id?: number;
      memo?: string;
      method?: string;
      modifyUser?: string;
      name?: string;
      parentId?: number;
      path?: string;
      sortNum?: number;
      status?: number;
      type?: number;
      visible?: boolean;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysResource/${id}`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: string; msg?: string }>,
  /**
   * No description
   * @name DELETE /xy/console/console/sysResource/{id}
   * @summary 删除
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: string, msg?: string }` successful operation
   */
  "/xy/console/console/sysResource/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/console/sysResource/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: string; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/console/sysResource/{id}
   * @summary 详情
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: { code?: string, createUser?: string, gmtCreated?: string, gmtModified?: string, icon?: string, id?: number, memo?: string, method?: string, modifyUser?: string, name?: string, parentId?: number, path?: string, sortNum?: number, status?: number, type?: number, visible?: boolean }, msg?: string }` successful operation
   */
  "/xy/console/console/sysResource/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/console/sysResource/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        code?: string;
        createUser?: string;
        gmtCreated?: string;
        gmtModified?: string;
        icon?: string;
        id?: number;
        memo?: string;
        method?: string;
        modifyUser?: string;
        name?: string;
        parentId?: number;
        path?: string;
        sortNum?: number;
        status?: number;
        type?: number;
        visible?: boolean;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/console/sysResource/{menu-id}/buttons-and-apis
   * @summary 根据菜单ID加载菜单下所有的接口资源和按钮资源
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: { apis?: (object)[], buttons?: (object)[] }, msg?: string }` successful operation
   */
  "/xy/console/console/sysResource/{menu-id}/buttons-and-apis_GET": (
    menuId: string,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysResource/${menuId}/buttons-and-apis`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: { apis?: object[]; buttons?: object[] }; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/console/sysResource/buttons-and-apis-batch
   * @summary 根据菜单ID加载菜单下所有的接口资源和按钮资源（批量）
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: ({ buttonAndApi?: { apiIds?: (number)[], buttonIds?: (number)[] }, menuId?: number })[], msg?: string }` successful operation
   */
  "/xy/console/console/sysResource/buttons-and-apis-batch_GET": (
    query: XyConsoleConsoleSysResourceButtonsAndApisBatchGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysResource/buttons-and-apis-batch`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: { buttonAndApi?: { apiIds?: number[]; buttonIds?: number[] }; menuId?: number }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/console/sysResource/tree
   * @summary 获取所有资源列表（树状结构）
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: ({ children?: (any)[], detail?: object, id?: number, key?: string, parentId?: number, sortNum?: number, title?: string })[], msg?: string }` successful operation
   */
  "/xy/console/console/sysResource/tree_GET": (
    query: XyConsoleConsoleSysResourceTreeGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/console/sysResource/tree`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        children?: any[];
        detail?: object;
        id?: number;
        key?: string;
        parentId?: number;
        sortNum?: number;
        title?: string;
      }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xy/console/surveyTemplates
   * @summary 创建
   * @tags 调研模板-模板管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/surveyTemplates_POST": (
    root: {
      description?: string;
      name: string;
      questions: { content?: string; enumChooseMode: number; options?: { name?: string; picUrl: string }[] }[];
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/surveyTemplates`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/surveyTemplates
   * @summary 搜索
   * @tags 调研模板-模板管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ createUser?: string, description: string, gmtCreated?: string, id: number, name: string, participantCnt?: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/surveyTemplates_GET": (
    query: XyConsoleSurveyTemplatesGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/surveyTemplates`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          createUser?: string;
          description: string;
          gmtCreated?: string;
          id: number;
          name: string;
          participantCnt?: number;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name DELETE /xy/console/surveyTemplates/{id}
   * @summary 删除
   * @tags 调研模板-模板管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/surveyTemplates/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/surveyTemplates/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/surveyTemplates/{id}
   * @summary 更新
   * @tags 调研模板-模板管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/surveyTemplates/{id}_PUT": (
    id: string,
    root: {
      description?: string;
      name: string;
      questions: { content?: string; enumChooseMode: number; options?: { name?: string; picUrl: string }[] }[];
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/surveyTemplates/${id}`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/surveyTemplates/{id}
   * @summary 详情
   * @tags 调研模板-模板管理
   * @response `200` `{ code?: number, data?: { description?: string, id: number, name: string, questions?: ({ content?: string, enumChooseMode: number, id: number, options: ({ id: number, name?: string, picUrl: string, questionId: number, templateId: number })[], templateId: number })[] }, msg?: string }` successful operation
   */
  "/xy/console/surveyTemplates/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/surveyTemplates/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        description?: string;
        id: number;
        name: string;
        questions?: {
          content?: string;
          enumChooseMode: number;
          id: number;
          options: { id: number; name?: string; picUrl: string; questionId: number; templateId: number }[];
          templateId: number;
        }[];
      };
      msg?: string;
    }>,
  /**
   * @description ## 请求示例 ``` { "id": 1, "status": false } ```
   * @name PUT /xy/console/banner/status
   * @summary 修改banner状态
   * @tags 首页banner相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/banner/status_PUT": (
    root: {
      gmtCreate?: string;
      gmtModified?: string;
      id?: number;
      imgUrl: string;
      jumpDesc?: string;
      jumpUrl?: string;
      sort: number;
      status: boolean;
      typeList: { bannerId?: number; gmtCreate?: string; id?: number; type?: number }[];
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/banner/status`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name DELETE /xy/console/banner/{id}
   * @summary 删除banner
   * @tags 首页banner相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/banner/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/banner/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/banner/{id}
   * @summary 查询banner详情
   * @tags 首页banner相关接口
   * @response `200` `{ code?: number, data?: { id?: number, imgUrl?: string, jumpDesc?: string, jumpUrl?: string, sort?: number, status?: boolean, typeList?: ({ bannerId?: number, gmtCreate?: string, id?: number, type?: number })[] }, msg?: string }` successful operation
   */
  "/xy/console/banner/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/banner/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        id?: number;
        imgUrl?: string;
        jumpDesc?: string;
        jumpUrl?: string;
        sort?: number;
        status?: boolean;
        typeList?: { bannerId?: number; gmtCreate?: string; id?: number; type?: number }[];
      };
      msg?: string;
    }>,
  /**
   * @description ## 请求示例 ``` { "imgUrl": "http://dummyimage.com/250x250", "sort": 1, "status": true, "typeList": [ { "type": 1 }, { "type": 2 } ] } ```
   * @name POST /xy/console/banner
   * @summary 新增banner
   * @tags 首页banner相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/banner_POST": (
    root: {
      gmtCreate?: string;
      gmtModified?: string;
      id?: number;
      imgUrl: string;
      jumpDesc?: string;
      jumpUrl?: string;
      sort: number;
      status: boolean;
      typeList: { bannerId?: number; gmtCreate?: string; id?: number; type?: number }[];
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/banner`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/banner
   * @summary 查询banner
   * @tags 首页banner相关接口
   * @response `200` `{ code?: number, data?: ({ id?: number, imgUrl?: string, jumpDesc?: string, jumpUrl?: string, sort?: number, status?: boolean, typeList?: ({ bannerId?: number, gmtCreate?: string, id?: number, type?: number })[] })[], msg?: string }` successful operation
   */
  "/xy/console/banner_GET": (query: XyConsoleBannerGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/banner`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        id?: number;
        imgUrl?: string;
        jumpDesc?: string;
        jumpUrl?: string;
        sort?: number;
        status?: boolean;
        typeList?: { bannerId?: number; gmtCreate?: string; id?: number; type?: number }[];
      }[];
      msg?: string;
    }>,
  /**
   * @description ## 请求示例 ``` { "id":1, "imgUrl": "http://dummyimage.com/", "sort": 11, "status": true, "typeList": [ { "type": 1 }, { "type": 2 } ] } ```
   * @name PUT /xy/console/banner
   * @summary 编辑banner
   * @tags 首页banner相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xy/console/banner_PUT": (
    root: {
      gmtCreate?: string;
      gmtModified?: string;
      id?: number;
      imgUrl: string;
      jumpDesc?: string;
      jumpUrl?: string;
      sort: number;
      status: boolean;
      typeList: { bannerId?: number; gmtCreate?: string; id?: number; type?: number }[];
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/banner`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/groups/mute
   * @summary 圈子封禁/取消封禁
   * @tags 圈子-圈子管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/groups/mute_PUT": (root: { decision?: boolean; groupId?: number }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/groups/mute`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/groups/{id}
   * @summary 圈子详情
   * @tags 圈子-圈子管理
   * @response `200` `{ code?: number, data?: { commentCnt?: number, createdTime?: string, creatorId: number, creatorNickname: string, enumStatus?: number, id: number, imgLogo?: string, leastLevel?: number, memberCnt?: number, name: string, normal?: boolean, postsCnt?: number, recommend?: boolean, subTitle: string, top?: boolean }, msg?: string }` successful operation
   */
  "/xy/console/groups/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/groups/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        commentCnt?: number;
        createdTime?: string;
        creatorId: number;
        creatorNickname: string;
        enumStatus?: number;
        id: number;
        imgLogo?: string;
        leastLevel?: number;
        memberCnt?: number;
        name: string;
        normal?: boolean;
        postsCnt?: number;
        recommend?: boolean;
        subTitle: string;
        top?: boolean;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/groups
   * @summary 搜索圈子列表
   * @tags 圈子-圈子管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ commentCnt?: number, createdTime?: string, creatorId: number, creatorNickname: string, enumStatus?: number, id: number, imgLogo?: string, leastLevel?: number, memberCnt?: number, name: string, normal?: boolean, postsCnt?: number, recommend?: boolean, subTitle: string, top?: boolean })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/groups_GET": (query: XyConsoleGroupsGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/groups`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          commentCnt?: number;
          createdTime?: string;
          creatorId: number;
          creatorNickname: string;
          enumStatus?: number;
          id: number;
          imgLogo?: string;
          leastLevel?: number;
          memberCnt?: number;
          name: string;
          normal?: boolean;
          postsCnt?: number;
          recommend?: boolean;
          subTitle: string;
          top?: boolean;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/groups/simple
   * @summary 简单搜索
   * @tags 圈子-圈子管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ creatorNickname?: string, id?: number, name?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/groups/simple_GET": (
    query: XyConsoleGroupsSimpleGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/groups/simple`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: { creatorNickname?: string; id?: number; name?: string }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xy/console/groups/top
   * @summary 置顶取消置顶
   * @tags 圈子-圈子管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/groups/top_PUT": (root: { decision?: boolean; groupId?: number }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/groups/top`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/groups/recommend
   * @summary 首页推荐/取消推荐
   * @tags 圈子-圈子管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/groups/recommend_PUT": (
    root: { decision?: boolean; groupId?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/groups/recommend`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/posts/visible
   * @summary 上架下架
   * @tags 帖子-帖子管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/posts/visible_PUT": (
    root: { decision?: boolean; groupId?: number; postsId?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/posts/visible`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name DELETE /xy/console/posts/{id}
   * @summary 删帖
   * @tags 帖子-帖子管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/posts/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/posts/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/posts/{id}
   * @summary 帖子详情
   * @tags 帖子-帖子管理
   * @response `200` `{ code?: number, data?: { allowReply?: boolean, attachments?: ({ enumType: number, id: number, postsId: number, url?: string })[], commentCnt?: number, comments?: ({ content?: string, groupId: number, id: number, mentionMemberId?: number, postsId: number, publishTime?: string, publisherId: number })[], content?: string, followedPublisher?: boolean, groupId: number, groupName?: string, id: number, likeCnt?: number, memberList?: ({ address?: { address?: string, city?: string, district?: string, gmtCreate?: string, id?: number, isDefault?: boolean, mobile?: string, name?: string, province?: string, userId?: number }, birthday?: string, family?: { boyBirthday?: (object)[], boyNum?: number, elderNum?: number, girlBirthday?: (object)[], girlNum?: number, id?: number, userId?: number }, groupCreator?: boolean, groupCreatorTime?: string, growth?: number, headImgUrl?: string, historyIntegral?: number, id?: number, integral?: number, level?: number, mail?: string, mobile?: string, nextGrowth?: number, nickname?: string, openid?: string, registerDate?: string, sex?: number, status?: boolean, tagList?: ({ gmtCreate?: string, id?: number, tagId?: number, tagName?: string, userId?: number })[] })[], publishTime?: string, publisherId: number, publisherNickname: string, sortNum?: number, top?: boolean, topicId?: number, topicName?: string, topics?: ({ id: number, postsId: number, topicId: number })[] }, msg?: string }` successful operation
   */
  "/xy/console/posts/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/posts/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        allowReply?: boolean;
        attachments?: { enumType: number; id: number; postsId: number; url?: string }[];
        commentCnt?: number;
        comments?: {
          content?: string;
          groupId: number;
          id: number;
          mentionMemberId?: number;
          postsId: number;
          publishTime?: string;
          publisherId: number;
        }[];
        content?: string;
        followedPublisher?: boolean;
        groupId: number;
        groupName?: string;
        id: number;
        likeCnt?: number;
        memberList?: {
          address?: {
            address?: string;
            city?: string;
            district?: string;
            gmtCreate?: string;
            id?: number;
            isDefault?: boolean;
            mobile?: string;
            name?: string;
            province?: string;
            userId?: number;
          };
          birthday?: string;
          family?: {
            boyBirthday?: object[];
            boyNum?: number;
            elderNum?: number;
            girlBirthday?: object[];
            girlNum?: number;
            id?: number;
            userId?: number;
          };
          groupCreator?: boolean;
          groupCreatorTime?: string;
          growth?: number;
          headImgUrl?: string;
          historyIntegral?: number;
          id?: number;
          integral?: number;
          level?: number;
          mail?: string;
          mobile?: string;
          nextGrowth?: number;
          nickname?: string;
          openid?: string;
          registerDate?: string;
          sex?: number;
          status?: boolean;
          tagList?: { gmtCreate?: string; id?: number; tagId?: number; tagName?: string; userId?: number }[];
        }[];
        publishTime?: string;
        publisherId: number;
        publisherNickname: string;
        sortNum?: number;
        top?: boolean;
        topicId?: number;
        topicName?: string;
        topics?: { id: number; postsId: number; topicId: number }[];
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xy/console/posts
   * @summary 搜索帖子列表
   * @tags 帖子-帖子管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ commentCnt?: number, content?: string, groupName?: string, id: number, likeCnt?: number, publishTime?: string, publisherId?: number, publisherNickname?: string, recommend?: boolean, shareCnt?: number, top?: boolean, visible?: boolean })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/posts_GET": (query: XyConsolePostsGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/posts`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          commentCnt?: number;
          content?: string;
          groupName?: string;
          id: number;
          likeCnt?: number;
          publishTime?: string;
          publisherId?: number;
          publisherNickname?: string;
          recommend?: boolean;
          shareCnt?: number;
          top?: boolean;
          visible?: boolean;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xy/console/posts/top
   * @summary 是否置顶
   * @tags 帖子-帖子管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/posts/top_PUT": (
    root: { decision?: boolean; groupId?: number; postsId?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/posts/top`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/posts/recommend
   * @summary 是否首页推荐
   * @tags 帖子-帖子管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xy/console/posts/recommend_PUT": (
    root: { postsId?: number; recommend?: boolean },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/posts/recommend`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xy/console/copywriter/{id}
   * @summary 查询运营文案
   * @tags 运营文案配置相关接口
   * @response `200` `{ code?: number, data?: { content?: string, id?: number }, msg?: string }` successful operation
   */
  "/xy/console/copywriter/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/copywriter/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: { content?: string; id?: number }; msg?: string }>,
  /**
   * No description
   * @name PUT /xy/console/copywriter
   * @summary 编辑运营文案
   * @tags 运营文案配置相关接口
   * @response `200` `File` successful operation
   */
  "/xy/console/copywriter_PUT": (
    root: { content?: string; gmtCreate?: string; gmtModified?: string; id?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xy/console/copywriter`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<File>,


  // 2022-3-1 新增接口 复制 
  /**
 * No description
 * @name GET console/tags/search
 * @summary 搜索标签
 * @tags 标签-标签管理
 * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ categoryId: number, categoryName: string, enabled: boolean, groupCnt: number, id: number, memberCnt: number, name: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
 */
  "/xy/console/tags/search_GET": (query: XyConsoleTagsGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xy/console/tags/search`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<any>,
  /**
   * No description
   * @name GET console/tags/search
   * @summary 分组标签 树状图  一级分组/二级分组/三级分组
   * @tags 标签-标签管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ categoryId: number, categoryName: string, enabled: boolean, groupCnt: number, id: number, memberCnt: number, name: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xy/console/user/tag_GET": (query: XyConsoleTagsGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/console/xy/user/tag`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<any>,


  // 2022-3-10 新增 
  /**
   * 商品名称 输入模糊下拉
   * @name GET /xy/console/goods
   * @summary 商品名称 输入模糊下拉
   * @tags 商品名称 输入模糊下拉
   * @response `200` `{ code?: number, data?: ({ id?: number, imgUrl?: string, jumpDesc?: string, jumpUrl?: string, sort?: number, status?: boolean, typeList?: ({ bannerId?: number, gmtCreate?: string, id?: number, type?: number })[] })[], msg?: string }` successful operation
   */
  "/xy/console/goods/name_GET": (
    query: { name: string }
  ) =>
    requestInstance({
      url: `/xy/console/goods/name`,
      method: "GET",
      params: query
    }) as unknown as Promise<File>,
  /**
  * 会员名称接口 输入模糊下拉
  * @name GET /xy/console/user/name
  * @summary 会员名称接口 输入模糊下拉
  * @tags 会员名称接口 输入模糊下拉 
  * @response `200` `{ code?: number, data?: ({ id?: number, imgUrl?: string, jumpDesc?: string, jumpUrl?: string, sort?: number, status?: boolean, typeList?: ({ bannerId?: number, gmtCreate?: string, id?: number, type?: number })[] })[], msg?: string }` successful operation
  */
  "/xy/console/user/name_GET": (
    query: { name: string }
  ) =>
    requestInstance({
      url: `/xy/console/user/name`,
      method: "GET",
      params: query
    }) as unknown as Promise<File>,
  // 2022-3-22 新增 
  /**
   * vlog 任务 列表
   * @name GET /xy/console/vlog]
   * @response `200`
   */
  "/xy/console/vlog_GET": (
    query: { [prop: string]: string }
  ) =>
    requestInstance({
      url: `/xy/console/vlog`,
      method: "GET",
      params: query
    }) as Promise<any>,
  /**
   * vlog 任务 编辑
   * @name PUT /xy/console/vlog
   * @response 
   */
  "/xy/console/vlog_PUT": (
    data: { [prop: string]: string }
  ) =>
    requestInstance({
      url: `/xy/console/vlog`,
      method: "PUT",
      data
    }) as Promise<any>,
  /**
   * vlog 任务 列表 导出数据  此处是 后端将数据传给前端 前端 自行 导出文件 
   * @name GET /xy/console/vlog/export
   * @summary 商品名称 输入模糊下拉
   * @tags 商品名称 输入模糊下拉
   * @response `200`
   */
  "/xy/console/vlog/export_POST": (
    data: { taskId: string }
  ) =>
    requestInstance({
      url: `/xy/console/vlog/export`,
      method: "POST",
      data
    }) as Promise<any>,

  // 2022-3-31 新增 
  /**
   * 未激活用户列表
   * @name POST /xy/console/user/dataTagUser]
   * @response `200`
   */
  "/xy/console/user/dataTagUser_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/xy/console/user/dataTagUser`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
  * 用户列表 接口 重写 为 
  * @name POST /xy/console/user/dataTagUser]
  * @response `200`
  */
  "/xy/console/user/pagedUser_POST": (
    data: { [prop: string]: any }
  ) => requestInstance({
    url: `/xy/console/user/pagedUser`,
    method: "POST",
    data
  }) as Promise<any>,
  // 2022-4-12 新增 公示文章模块 接口
  /**
   * 新增/修改 公示文章 
   * @name POST /xy/console/publicInformation/saveOrSubmitArticle
   * @response `200`
   */
  "/xy/console/publicInformation/saveOrSubmitArticle_POST": (
    data: { [prop: string]: string }
  ) => requestInstance({
    url: `/xy/console/publicInformation/saveOrSubmitArticle`,
    method: "POST",
    data
  }) as Promise<any>,
  /**
   * 启用/禁用 公示文章 
   * @name POST /xy/console/publicInformation/enableArticle
   * @response `200`
   */
  "/xy/console/publicInformation/enableArticle_POST": (
    data: { id: string, status: string }
  ) => requestInstance({
    url: `/xy/console/publicInformation/enableArticle`,
    method: "POST",
    data
  }) as Promise<any>,
  /**
   * 删除 公示文章 
   * @name POST /xy/console/publicInformation/deleteArticle
   * @response `200`
   */
  "/xy/console/publicInformation/deleteArticle_POST": (
    params: { id: string }
  ) => requestInstance({
    url: `/xy/console/publicInformation/deleteArticle`,
    method: "POST",
    params
  }) as Promise<any>,
  /**
   * 公示文章 列表
   * @name GET /xy/console/publicInformation/pagedArticle
   * @response `200`
   */
  "/xy/console/publicInformation/pagedArticle_GET": (
    query: { [prop: string]: string }
  ) =>
    requestInstance({
      url: `/xy/console/publicInformation/pagedArticle`,
      method: "GET",
      params: query
    }) as Promise<any>,
  /**
  * 公示文章 详情
  * @name GET /xy/console/publicInformation/getArticle
  * @response `200`
  */
  "/xy/console/publicInformation/getArticle_GET": (
    query: { id: string }
  ) =>
    requestInstance({
      url: `/xy/console/publicInformation/getArticle`,
      method: "GET",
      params: query
    }) as Promise<any>,
  /**
   * 稀有 用户列表
   * @name GET /xy/console/console/sysUser/listSysUser
   * @response `200` {username: '', id: ''}[]
   */
  "/xy/console/console/sysUser/listSysUser_GET": (
    query: { username: string }
  ) =>
    requestInstance({
      url: `/xy/console/console/sysUser/listSysUser`,
      method: "GET",
      params: query
    }) as Promise<any>,
  /**
   * 稀有 用户分组列表
   * @name POST /xy/console/crmGroup/pageList
   * @response `200` 
   */
  "/xy/console/crmGroup/pageList_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/xy/console/crmGroup/pageList`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 用户分组用户列表
   * @name POST /console/crmGroupMember/pageList
   * @response `200` 
   */
  "/console/crmGroupMember/pageList_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmGroupMember/pageList`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 用户分组新建分组
   * @name POST /console/crmGroup/createCrmGroup
   * @response `200` 
   */
  "/console/crmGroup/createCrmGroup_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmGroup/createCrmGroup`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 用户分组删除分组
   * @name POST /console/crmGroup/deleteGroup
   * @response `200` 
   */
  "/console/crmGroup/deleteGroup_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmGroup/deleteGroup`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 用户分组新增用户
   * @name POST /console/crmGroupMember/addMembers
   * @response `200` 
   */
  "/console/crmGroupMember/addMembers_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmGroupMember/addMembers`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 用户分组删除用户
   * @name POST /console/crmGroupMember/deleteMember
   * @response `200` 
   */
  "/console/crmGroupMember/deleteMember_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmGroupMember/deleteMember`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 用户分组查询当前分组详情
   * @name GET /console/crmGroup/detail
   * @response `200` 
   */
  "/console/crmGroup/detail_GET": (
    query: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmGroup/detail`,
      method: "GET",
      params: query
    }) as Promise<any>,
  /**
   * 稀有 crm短信管理消息分页
   * @name GET /console/crmMessage/pagedMessage
   * @response `200` 
   */
  "/console/crmMessage/pagedMessage_GET": (
    query: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/pagedMessage`,
      method: "GET",
      params: query
    }) as Promise<any>,
  /**
   * 稀有 crm短信管理用户分页
   * @name GET /console/crmMessage/pagedCRMUser
   * @response `200` 
   */
  "/console/crmMessage/pagedCRMUser_GET": (
    query: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/pagedCRMUser`,
      method: "GET",
      params: query
    }) as Promise<any>,
    /**
     * 稀有 查询短信添加用户状态
     * @name GET /console/crmMessage/messageUserProcessingInfo
     * @response `200` 
     */
    "/console/crmMessage/messageUserProcessingInfo_GET": (
      query: { [prop: string]: any }
    ) =>
      requestInstance({
        url: `/console/crmMessage/messageUserProcessingInfo`,
        method: "GET",
        params: query
      }) as Promise<any>,
  /**
   * 稀有 投递消息
   * @name POST /console/crmMessage/SendMessage
   * @response `200` 
   */
  "/console/crmMessage/SendMessage_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/SendMessage`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 编辑投递消息
   * @name POST /console/crmMessage/editMessage
   * @response `200` 
   */
  "/console/crmMessage/editMessage_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/editMessage`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 发送测试消息
   * @name POST /console/crmMessage/sendTestMessage
   * @response `200` 
   */
  "/console/crmMessage/sendTestMessage_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/sendTestMessage`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 手动添加CRM用户
   * @name POST /console/crmMessage/addCRMUser
   * @response `200` 
   */
  "/console/crmMessage/addCRMUser_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/addCRMUser`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 删除CRM用户
   * @name POST /console/crmMessage/deleteCRMUser
   * @response `200` 
   */
  "/console/crmMessage/deleteCRMUser_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/deleteCRMUser`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 crm短信管理签名列表
   * @name GET /console/crmMessage/listSign
   * @response `200` 
   */
  "/console/crmMessage/listSign_GET": (
    query: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/listSign`,
      method: "GET",
      params: query
    }) as Promise<any>,
  /**
   * 稀有 从分组导入CRM用户
   * @name POST /console/crmMessage/importCRMUser
   * @response `200` 
   */
  "/console/crmMessage/importCRMUser_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/importCRMUser`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 获取短信id
   * @name POST /console/crmMessage/getLatestMessageId
   * @response `200` 
   */
  "/console/crmMessage/getLatestMessageId_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/getLatestMessageId`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 获取视频列表
   * @name GET /console/crmMessage/listVideoTemplate
   * @response `200` 
   */
   "/console/crmMessage/listVideoTemplate_GET": (
    query: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/listVideoTemplate`,
      method: "GET",
      params: query
    }) as Promise<any>,
    /**
     * 稀有 删除crm投递消息
     * @name POST /console/crmMessage/deleteMessage
     * @response `200` 
     */
    "/console/crmMessage/deleteMessage_POST": (
      data: { [prop: string]: any }
    ) =>
      requestInstance({
        url: `/console/crmMessage/deleteMessage`,
        method: "POST",
        data
      }) as Promise<any>,
    /**
     * 稀有 获取视频短链
     * @name POST /console/crmMessage/handleUrl
     * @response `200` 
     */
    "/console/crmMessage/handleUrl_POST": (
      data: { [prop: string]: any }
    ) =>
      requestInstance({
        url: `/console/crmMessage/handleUrl`,
        method: "POST",
        data
      }) as Promise<any>,
    /**
     * 稀有 限制短信发送人数
     * @name POST /console/crmMessage/limitSendCnt
     * @response `200` 
     */
    "/console/crmMessage/limitSendCnt_POST": (
      data: { [prop: string]: any }
    ) =>
      requestInstance({
        url: `/console/crmMessage/limitSendCnt`,
        method: "POST",
        data
      }) as Promise<any>,
    /**
     * 稀有 限制短信发送人数
     * @name POST /console/crmMessage/getLimitSendCnt
     * @response `200` 
     */
    "/console/crmMessage/getLimitSendCnt_POST": (
      data: { [prop: string]: any }
    ) =>
      requestInstance({
        url: `/console/crmMessage/getLimitSendCnt`,
        method: "POST",
        data
      }) as Promise<any>
};
